export default "/images/vendor/flag-icon-css/flags/4x3/se.svg?22333e71c0c3e3d8da11f6e7985c622b";